var Wallop = require("wallop");
var anime = require("animejs/lib/anime.js");
var Equalizer = require("equalizer");
var PubSub = require("underpub-js");

var servicesMarketsCarousel = function(options) {
  this.options = {
    $el: false,
  };

  $.extend(true, this.options, options);
};

servicesMarketsCarousel.prototype.init = function() {
  var self = this;

  this.sliderColors = ["#73AF55", "#FF6700", "#00B4FF", "#fce803", "#f22000"];

  // init sliders

  var imagesSlider = this.options.$el.find(".image-slider")[0]; // wallop takes a plain JS element, so use [0]
  this.imagesWallop = new Wallop(imagesSlider);

  var linkSlider = this.options.$el.find(".link-slider")[0]; // wallop takes a plain JS element, so use [0]
  this.linkWallop = new Wallop(linkSlider);

  var projectSlider = this.options.$el.find(".featured-project-slider")[0]; // wallop takes a plain JS element, so use [0]
  this.projectWallop = new Wallop(projectSlider);

  // on slide change
  var slideChange = function(event) {
    var activeSlideNum = event.detail.currentItemIndex;
  };

  // attach to any one of the sliders, since they'll all be triggered together
  this.imagesWallop.on("change", slideChange);

  this.options.$el
    .find(".slider-nav-arrows .slider-prev")
    .on("click", function() {
      self.animateSlideTransition("prev");

      window.setTimeout(function() {
        self.prevSlide();
      }, 400);

      self.pauseSlider();
    });

  this.options.$el
    .find(".slider-nav-arrows .slider-next")
    .on("click", function() {
      self.animateSlideTransition("next");

      window.setTimeout(function() {
        self.nextSlide();
      }, 400);

      self.pauseSlider();
    });

  this.options.$el.find(".play-pause-btn").on("click", function() {
    if ($(this).hasClass("playing")) {
      self.options.$el.find(".play-pause-btn").removeClass("playing");
      self.options.$el.find(".play-pause-btn").addClass("paused");
      self.pauseSlider();
    } else if ($(this).hasClass("paused")) {
      self.options.$el.find(".play-pause-btn").removeClass("paused");
      self.options.$el.find(".play-pause-btn").addClass("playing");
      self.playSlider();
    }
  });

  this.startCountdown();
};

servicesMarketsCarousel.prototype.animateSlideTransition = function(
  transitionDirection,
) {
  var self = this;

  var animationSpeed = 450;
  var startingOffset = 500;
  var incrementOffset = 200;

  var $olImageSlide = this.options.$el.find(
    ".image-slider .Wallop-item--current",
  );

  // determine the image slide we're going to show next
  if (transitionDirection == "prev") {
    if ($olImageSlide.prev().length) {
      var $imageSlideToShow = $olImageSlide.prev();
    } else {
      var $imageSlideToShow = this.options.$el
        .find(".text-content-slider .Wallop-item")
        .last();
    }
  } else {
    if ($olImageSlide.next().length) {
      var $imageSlideToShow = $olImageSlide.next();
    } else {
      var $imageSlideToShow = this.options.$el
        .find(".text-content-slider .Wallop-item")
        .first();
    }
  }

  // link slider
  var $oldLinkSlide = this.options.$el.find(
    ".link-slider .Wallop-item--current",
  );

  // determine the text content slide we're going to show next
  if (transitionDirection == "prev") {
    if ($oldLinkSlide.prev().length) {
      var $linkSlideToShow = $oldLinkSlide.prev();
    } else {
      var $linkSlideToShow = this.options.$el
        .find(".link-slider .Wallop-item")
        .last();
    }
  } else {
    if ($oldLinkSlide.next().length) {
      var $linkSlideToShow = $oldLinkSlide.next();
    } else {
      var $linkSlideToShow = this.options.$el
        .find(".link-slider .Wallop-item")
        .first();
    }
  }

  // text content slider animation
  var linkSliderAnimeTimeline = anime.timeline();

  var linkToHide = $oldLinkSlide.find("a")[0];
  var linkToShow = $linkSlideToShow.find("a")[0];

  // hide non-active text so they don't show through when the slide starts changing (they'll be faded in if we want them to show)
  this.options.$el
    .find(".link-slider .Wallop-item:not(.Wallop-item--current) a")
    .css("opacity", 0);

  // move items to the left so we can fade it in from the left
  $linkSlideToShow.find("a").css("transform", "translateX(-32px)");

  linkSliderAnimeTimeline
    // bump old link right and fade out
    .add(
      {
        targets: [linkToHide],
        opacity: 0,
        translateX: 32,
        duration: 200,
        easing: window.easings.ease,
      },
      100,
    )

    // fade in new heading
    .add(
      {
        targets: [linkToShow],
        opacity: 1,
        translateX: 0,
        duration: 200,
        easing: window.easings.ease,
      },
      461,
    );

  // project slider
  var $oldProjectSlide = this.options.$el.find(
    ".featured-project-slider .Wallop-item--current",
  );

  // determine the text content slide we're going to show next
  if (transitionDirection == "prev") {
    if ($oldProjectSlide.prev().length) {
      var $projectSlideToShow = $oldProjectSlide.prev();
    } else {
      var $projectSlideToShow = this.options.$el
        .find(".featured-project-slider .Wallop-item")
        .last();
    }
  } else {
    if ($oldProjectSlide.next().length) {
      var $projectSlideToShow = $oldProjectSlide.next();
    } else {
      var $projectSlideToShow = this.options.$el
        .find(".featured-project-slider .Wallop-item")
        .first();
    }
  }

  // text content slider animation
  var projectSliderAnimeTimeline = anime.timeline();

  var projectLinkToHide = $oldProjectSlide.find("a")[0];
  var projectLinkToShow = $projectSlideToShow.find("a")[0];

  // hide non-active text so they don't show through when the slide starts changing (they'll be faded in if we want them to show)
  this.options.$el
    .find(".featured-project-slider .Wallop-item:not(.Wallop-item--current) a")
    .css("opacity", 0);

  // move items to the left so we can fade it in from the left
  $projectSlideToShow.find("a").css("transform", "translateX(-32px)");

  projectSliderAnimeTimeline
    // bump old link right and fade out
    .add(
      {
        targets: [projectLinkToHide],
        opacity: 0,
        translateX: 32,
        duration: 200,
        easing: window.easings.ease,
      },
      100,
    )

    // fade in new heading
    .add(
      {
        targets: [projectLinkToShow],
        opacity: 1,
        translateX: 0,
        duration: 200,
        easing: window.easings.ease,
      },
      461,
    );

  // link slider background animation

  // get index of current slide
  var slideCount = 0;
  var slideIndexToShow = 0;

  this.options.$el.find(".image-slider .Wallop-item").each(function() {
    if ($(this)[0] == $imageSlideToShow[0]) {
      slideIndexToShow = slideCount;
    }
    slideCount++;
  });

  var newColor = this.sliderColors[slideIndexToShow % this.sliderColors.length];

  var $backgroundColorDiv = self.options.$el.find(
    ".right .link-slider-wrap .background-color",
  );
  var $backgroundColorReplacerDiv = self.options.$el.find(
    ".right .link-slider-wrap .background-color-replacer",
  );

  $backgroundColorReplacerDiv
    .css("background-color", newColor)
    .addClass("replace");

  window.setTimeout(function() {
    $backgroundColorDiv.css("background-color", newColor);
    $backgroundColorReplacerDiv.removeClass("replace");
  }, 500);
};

servicesMarketsCarousel.prototype.stopCountdown = function() {
  clearInterval(this.countdownInterval);
};

servicesMarketsCarousel.prototype.startCountdown = function() {
  var self = this;

  this.startCountdownAnimation();

  this.countdownInterval = window.setInterval(function() {
    self.animateSlideTransition("next");

    window.setTimeout(function() {
      self.nextSlide();
    }, 400);

    self.startCountdownAnimation();
  }, 8000);
};

servicesMarketsCarousel.prototype.startCountdownAnimation = function() {
  // reset the animation by removing and re-adding the play/pause button
  var $origEl = this.options.$el.find(".play-pause-btn").first();

  var $newEl = $origEl.clone(true);

  $newEl.removeClass("playing");

  // remove the existing element
  $origEl.remove();

  // add the new element
  this.options.$el.find(".play-pause-btn-wrap").append($newEl);

  // add the playing class to kick off the animation
  this.options.$el.find(".play-pause-btn").addClass("playing");
};

servicesMarketsCarousel.prototype.pauseSlider = function() {
  const $playPauseButton = this.options.$el.find(".play-pause-btn");
  $playPauseButton.removeClass("play playing").addClass("paused");
  this.stopCountdown();
};

servicesMarketsCarousel.prototype.playSlider = function() {
  const $playPauseButton = this.options.$el.find(".play-pause-btn");
  $playPauseButton.removeClass("paused").addClass("playing play");
  this.startCountdown();
};

servicesMarketsCarousel.prototype.prevSlide = function() {
  this.imagesWallop.previous();
  this.linkWallop.previous();
  this.projectWallop.previous();
};

servicesMarketsCarousel.prototype.nextSlide = function() {
  this.imagesWallop.next();
  this.linkWallop.next();
  this.projectWallop.next();
};

module.exports = servicesMarketsCarousel;
